var termToUrl = function termToUrl() {
  var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
  return term.trim().replace(/ \+ /g, '+++').replace(/([^+ ])\+(?=[^+]|$)/g, '$1++').replace(/(\s|\/|-)/g, '+');
};
export default termToUrl;